<template lang="pug">
  div
    v-combobox(v-model="ArrayFieldDates" :label="label" prepend-inner-icon="mdi-calendar-month" @click="modal=true" hide-details readonly clearable)
    v-dialog(ref="dialog" v-model="modal" persistent width="300px")
      v-date-picker(v-model="datePickerDates" :first-day-of-week="1" scrollable multiple color="red")
        v-spacer
        v-btn( text color="ared" @click="modal = false" ) Cancel
        v-btn( text color="success" @click="onDatePicked" ) OK
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    label: { type: String, default: '' },
    pickDate: { type: Array, default: () => { return [] } }
  },
  data: () => ({
    datePickerDates: [],
    modal: false,
    ArrayFieldDates: []
  }),

  computed: {
  },

  watch: {
    pickDate: {
      deep: true,
      handler (val) {
        this.ArrayFieldDates = val.map(v => {
          return this.formatDate(v)
        })
        this.datePickerDates = [...val]
      }
    },
    ArrayFieldDates: {
      deep: true,
      handler (val) {
        if (!val) {
          this.datePickerDates = []
          this.$emit('pick', [])
        }
      }
    }
  },

  mounted () {
    if (this.pickDate.length > 0) {
      // this.ArrayFieldDates = [...this.formatDate(this.pickDate)
      this.ArrayFieldDates = [ ...this.pickDate.map(p => { return this.formatDate(p) }) ]
      // this.datePickerDates = this.pickDate.substr(0, 10)
      this.datePickerDates = [ ...this.pickDate.map(p => { return p.substr(0, 10) }) ]
    }
  },

  methods: {
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}`
    },
    onDatePicked () {
      this.ArrayFieldDates = this.datePickerDates.map(d => { return this.formatDate(d) })
      // this.textFieldDate = this.formatDate(this.datePickerDate)
      this.$emit('pick', this.datePickerDates)
      this.modal = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
